import { RootStore } from '../../stores/root.store';
import { AdContainerStore } from '../../stores/ad-container.store';
import { reaction } from '../../utils/preact-utils';
import { updateMraidInfos } from '../../sentry';

export class SentryTagsHandler {
  rootStore: RootStore;
  adContainerStore: AdContainerStore;

  constructor(store: RootStore) {
    this.rootStore = store;
    this.adContainerStore = this.rootStore.adContainerStore;

    this.initObservers();
  }

  initObservers(): void {
    reaction(
      () => this.adContainerStore.state.value,
      state => {
        updateMraidInfos({ state: state });
      }
    );

    reaction(
      () => this.adContainerStore.isViewable.value,
      isViewable => {
        updateMraidInfos({ isViewable: isViewable });
      }
    );
  }
}
